import { render, staticRenderFns } from "./AdministracionView.vue?vue&type=template&id=0a3c654a&scoped=true"
import script from "./AdministracionView.vue?vue&type=script&lang=js"
export * from "./AdministracionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3c654a",
  null
  
)

export default component.exports